import React from 'react';
import { Autocomplete, Box, TextField } from '@material-ui/core';
import { languages } from 'countries-list';
import PropTypes from 'prop-types';

const LanguageSelect = ({ TextFieldProps, ...rest }) => {
  return (
    <Autocomplete
      id="language-select"
      options={Object.keys(languages)}
      autoHighlight
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          {languages[option]?.name} ({option})
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          {...TextFieldProps}
          InputProps={{
            ...params.InputProps,
            ...TextFieldProps?.InputProps,
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            ...TextFieldProps?.InputLabelProps,
          }}
        />
      )}
      {...rest}
    />
  );
};

LanguageSelect.propTypes = {
  TextFieldProps: PropTypes.object,
};

export default LanguageSelect;
